import { Service } from '../../interfaces/service.interface';
import { constantes } from '../../constantes';
import { ParamsService } from '../../services/params.service';
import { DataService } from '../../services/data.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'app-page-service',
  templateUrl: './page-service.component.html',
	styleUrls: ['./page-service.component.scss'],
	
})
export class PageServiceComponent implements OnInit {

	form:FormGroup;
	subtry:boolean;
	constantes:any = constantes;
	filterOpen:boolean;
	
	items:{}[];
	
	
  constructor(
		private _fb:FormBuilder,
		public dataService:DataService,
		public breakpointObserver: BreakpointObserver,
		private paramsService:ParamsService,
	) { }
	
  ngOnInit() {
		let validation:any =null;
		let valuedefault:boolean = false;
		
		this.form = this._fb.group({
			restaurant: [valuedefault, validation],
			hotel: [valuedefault, validation],
			parkingVL: [valuedefault, validation],
			parkingPL: [valuedefault, validation],
			tourism: [valuedefault, validation],
			servicesauto: [valuedefault, validation],
                        appontementcroisieriste: [valuedefault, validation],   
                        appontementmarinier: [valuedefault, validation],
                        appontementmixte: [valuedefault, validation],
                        dechets: [valuedefault, validation]
			// ferry: ['', validation],
		});
		
		this.form.valueChanges.subscribe(
			resp => {
				this.dataService.filterService(resp);
			}
		);
		
		
		let mobile:boolean = this.breakpointObserver.isMatched('(max-width: 768px)');
		this.filterOpen = !mobile;
		
		this.breakpointObserver
		.observe(['(max-width: 768px)'])
		.subscribe((state: BreakpointState) => {
			if (!state.matches) this.filterOpen = true;
			else this.filterOpen = false;
		});
		
		
	}
	
	
	toggleFilter()
	{
		this.filterOpen = !this.filterOpen;
		
	}
	
	
	onLocalize(item:Service):void
	{
		item.rubric = 'services';
		this.paramsService.dispatch('localize', item);
	}

}